import { updateObject } from "../../shared/utility";
import { globalConstants, shopifyConstants } from "../../constants";

//-------InitialState of the reducer
const initialState = {
  shopifyTags: [],
  shopifyOrders: [],
  shopifySettings: {},
  shopifyThemeTemplates: [],
  eligibleShopifyLocations: [],
  shopifyOrderNotificationModalDetails: {},
  isShowShopifyOrderNotificationModal: false,
};

//-------Export shopify Reducer
export const shopify = (state = initialState, action) => {
  switch (action.type) {
    case shopifyConstants.GET_SHOPIFY_PRESETS + globalConstants.SUCCESS:
      return updateObject(state, {
        shopifySettings: action.data || {},
      });
    case shopifyConstants.GET_SHOPIFY_PRESETS + globalConstants.FAILURE:
      return updateObject(state, {
        shopifySettings: {},
      });
    case shopifyConstants.GET_SHOPIFY_PRESETS_BY_ID + globalConstants.SUCCESS:
      return updateObject(state, {
        productMappings: action.data || {},
      });
    case shopifyConstants.GET_SHOPIFY_ORDERS + globalConstants.SUCCESS:
      return updateObject(state, {
        shopifyOrders: action.data || [],
      });
    case shopifyConstants.GET_SHOPIFY_ORDERS + globalConstants.FAILURE:
      return updateObject(state, {
        shopifyOrders: [],
      });
    case shopifyConstants.GET_SHOPIFY_PRODUCT_TAGS + globalConstants.SUCCESS:
      return updateObject(state, {
        shopifyTags: action?.data?.shopifyTags?.productTags?.edges || [],
      });
    case shopifyConstants.GET_SHOPIFY_PRODUCT_TAGS + globalConstants.FAILURE:
      return updateObject(state, {
        shopifyTags: [],
      });
    case shopifyConstants.GET_SHOPIFY_THEME_TEMPLATES + globalConstants.SUCCESS:
      return updateObject(state, {
        shopifyThemeTemplates: action?.data?.shopifyThemeTemplates || [],
      });
    case shopifyConstants.GET_SHOPIFY_THEME_TEMPLATES + globalConstants.FAILURE:
      return updateObject(state, {
        shopifyThemeTemplates: [],
      });
    case shopifyConstants.GET_ELIGIBLE_SHOPIFY_LOCATIONS +
      globalConstants.SUCCESS:
      return updateObject(state, {
        eligibleShopifyLocations: action.data || [],
      });
    case shopifyConstants.GET_ELIGIBLE_SHOPIFY_LOCATIONS +
      globalConstants.FAILURE:
      return updateObject(state, {
        eligibleShopifyLocations: [],
      });
    case shopifyConstants.TOGGLE_SHOPIFY_ORDER_NOTIFICATION_MODAL:
      return updateObject(state, {
        isShowShopifyOrderNotificationModal: action.data,
      });
    case shopifyConstants.GET_SHOPIFY_ORDER_NOTIFICATION_MODAL_DETAILS +
      globalConstants.SUCCESS:
      return updateObject(state, {
        shopifyOrderNotificationModalDetails: action.data || {},
      });
    case shopifyConstants.GET_SHOPIFY_ORDER_NOTIFICATION_MODAL_DETAILS +
      globalConstants.FAILURE:
      return updateObject(state, {
        shopifyOrderNotificationModalDetails: action.data || {},
      });
    case shopifyConstants.RESET_SHOPIFY_TO_EMPTY:
      return initialState;
    //-------Default State
    default:
      return state;
  }
};
